<template>
	<div class="text-center main-container white">
		<h2>
			{{ 'Current task' | translate }}
			<!-- "{{ 'Slide' | translate }} {{ order }}" -->
		</h2>
		<template v-if="!isDisabledWH">
			<h4>
				{{ 'You need to complete the exercises' | translate }} :
				{{ homework.homeworks_left }}
			</h4>
			<table style="width: 100%; max-width: 600px;margin: 20px auto;">
				<tr>
					<th colspan="1">№</th>
					<th colspan="1">{{ 'Only task' | translate }}</th>
					<th colspan="1">{{ 'Level' | translate }}</th>
					<th colspan="1">{{ 'Complexity' | translate }}</th>
					<th colspan="1">{{ 'Action with number' | translate }}</th>
					<th colspan="1">{{ 'Number of expression' | translate }}</th>
				</tr>
				<tr></tr>
				<tr>
					<td>{{ 1 }}</td>
					<td>
						{{
							`match.${game.with_columns ? 'column' : game.type}` | translate
						}}
					</td>
					<td>
						{{
							game.digit_type.replace('_', ' ')
							| getGameLabel
							| translate
							| textCapitalize
						}}
						<!--						 !game.digit.length ? '' : game.digit -->
					</td>
					<td>{{ game.difficult }}</td>
					<td>{{ game.operation_number }}</td>
					<td>{{ game.repeat }}</td>
				</tr>
				<tr v-for="(game, itemIndex) in homework.games" :key="game.id">
					<td>{{ itemIndex + 2 }}</td>
					<td>
						{{
							game.with_columns
								? 'match.column'
								: ('match.' + game.type) | translate
						}}
					</td>
					<td>
						{{
							game.digit_type.replace('_', ' ')
							| getGameLabel
							| translate
							| textCapitalize
						}}
						{{ !game.digit.length ? '' : game.digit }}
					</td>
					<td>{{ game.difficult }}</td>
					<td>{{ game.operation_number }}</td>
					<td>{{ game.repeat }}</td>
				</tr>
			</table>

			<div v-if="!game.with_columns" class="input-number">
				<button @click="
					changeSpeed(-0.1)
				changedSpeed = true
					" class="btn btn-blue">
					-
				</button>

				<input v-model="game.speed" step="0.1" :disabled="(game.speed < 1 && game.difficult <= 10) ||
					(game.difficult >= 100 && game.speed < 2.5)
					" type="number" />

				<button @click="
					changeSpeed(0.1)
				changedSpeed = true
					" class="btn btn-blue">
					+
				</button>
			</div>
			<div class="justify-content-center form-inline">
				<label v-if="!game.with_columns" class=" mb-2 mr-sm-2 mb-sm-0">
					<input :disabled="game.speed < 1" v-model="withSound" type="checkbox" class="form-check-input" />
					<span class="custom-control-indicator"></span>
					<span class="custom-control-description">{{
						'Sound' | translate
					}}</span>
				</label>
				<!--				<language-select-->
				<!--					:value="language"-->
				<!--					@change="value => (language = value)"-->
				<!--					class="custom-select mb-2 mr-sm-2 mb-sm-0"-->
				<!--				/>-->
			</div>
		</template>

		<template v-if="homework && homework.games.length && isDisabledWH">
			<h5>{{ isDisabledWH ? 'Tasks' : 'Next tasks' | translate }}:</h5>

			<table style="width: 100%; max-width: 600px;margin: 20px auto;">
				<tr>
					<th colspan="1">№</th>
					<th colspan="1">{{ 'Only task' | translate }}</th>
					<th colspan="1">{{ 'Level' | translate }}</th>
					<th colspan="1">{{ 'Complexity' | translate }}</th>
					<th colspan="1">{{ 'Action with number' | translate }}</th>
					<th colspan="1">{{ 'Number of expression' | translate }}</th>
				</tr>

				<tr class="table-row" v-for="(game, itemIndex) in homework.games" :key="game.id">
					<td>{{ itemIndex + 1 }}</td>
					<td>
						{{
							game.with_columns
								? 'match.column'
								: ('match.' + game.type) | translate
						}}
					</td>
					<td>
						{{
							game.digit_type.replace('_', ' ')
							| getGameLabel
							| translate
							| textCapitalize
						}}
						{{ !game.digit.length ? '' : game.digit }}
					</td>
					<td>{{ game.difficult }}</td>
					<td>{{ game.operation_number }}</td>
					<td>{{ game.repeat }}</td>
				</tr>
			</table>
		</template>

		<div>
			<p v-if="this.$route.query.read_only">
				{{ "You cannot do homework in the student's platform" | translate }}
			</p>
		</div>
		<div class="col-12 text-uppercase">
			<button v-if="!isDisabledWH" @click="startGame" class="text-uppercase btn btn-success">
				{{ 'Start' | translate }}
			</button>
			<a @click.prevent="$router.go(-1)" class="btn btn-pink">{{
				'Back' | translate
			}}</a>
		</div>
	</div>
</template>

<script>
import { getTime } from '@/helpers/getTime'

export default {
	name: 'homework',
	data() {
		return {
			array: [1, 2, 3],
			homework: null,
			initialTimer: 0,
			game: {
				speed: 1,
			},
			changedSpeed: false,
			deadline: null,
			order: null,
			withSound: true,
			isDisabledWH: true,
			language: this.$i18n.locale() === 'ua' ? 'uk' : this.$i18n.locale(),
		}
	},
	filters: {
		textCapitalize(str) {
			return !str ? '' : `${str[0].toUpperCase()}${str.slice(1)}`
		},
		getGameLabel(str) {
			if (str === 'negative') {
				return 'games.negativeNumbers'
			} else if (str === 'divide') {
				return 'match.divide'
			} else {
				return str
			}
		},
	},
	methods: {
		startGame() {
			//TODO: remove timer config
			let timer = {
				isTimerEnabled: false,
				timerCount: 30
			}

			if (this.game.with_columns && this.game.game_data) {
				const newTimer = JSON.parse(this.game.game_data)

				timer = {
					...timer,

					isTimerEnabled: newTimer.isTimerEnabled,
					timerCount: Number(newTimer.timerCount)
				}
			}

			let data = {
				withSound:
					this.game.digit_type === 'multiply' ||
						this.game.digit_type === 'multiply_quad' ||
						this.game.digit_type === 'multiply_base' ||
						this.game.digit_type === 'multiply_50_100' ||
						this.game.digit_type === 'divide' ||
						(this.game.speed < 1 && this.game.difficult <= 10) ||
						(this.game.difficult >= 100 && this.game.speed < 2.5)
						? false
						: this.withSound,
				language: this.language,
				speed: this.game.speed,
				changedSpeed: this.changedSpeed,
				homework: this.homework.id,
				read_only: this.$route.query.read_only,
				...(this.game.with_columns && { ...timer })
			}
			this.$store.commit('changeGameConfig', data)
			this.$router.push({ path: '/games/game' })
		},
		changeSpeed(val) {
			if (+this.game.speed === 0.1 && val === -0.1) {
				return false
			}
			let newVal = +this.game.speed + val
			this.game.speed = newVal.toFixed(1)
			this.withSound = this.game.speed >= 1
		},
	},
	created() {
		let deadline = getTime(this.$route.query.date)
		this.deadline = deadline.toISODate()
		this.order = this.$route.query.order
		let playerId = this.$route.query.read_only
			? this.$route.query.read_only
			: this.$store.state.myProfile.id
		this.axios({
			method: 'get',
			url: `lessons/homeworks/${this.$route.query.id}?user=${playerId}`,
		}).then(resp => {
			this.homework = resp.data
			this.isDisabledWH = false
			let newGames = []

			this.homework.games.forEach(game => {
				let newGamesData = []
				game.data.forEach(data => {
					if (!data.is_right_answer) {
						newGamesData.push(data)
					}
				})
				game.data = newGamesData
				if (game.data.length > 0) {
					newGames.push(game)
				}
			})
			this.homework.games = newGames
			this.game = this.homework.games.splice(0, 1)[0]

			this.withSound = this.game?.is_muted ? false : true;
		})
	},
	beforeCreate() {
		if (!this.$route.query.id || !this.$route.query.date) {
			this.$router.push('/dashboard-student/homework')
		}
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.table-row {
	position: relative;
}

.done {
	font-size: 32px;
	padding-top: 5px;
	display: flex;
	width: 30px;
	height: 30px;
	justify-content: center;
	align-items: center;
	/*background: #fff;*/
	/*border-radius: 10em;*/
	position: absolute;
	color: #00b200;
	right: -40px;
	top: 50%;
	transform: translateY(-50%);
}

table,
th,
td {
	border: 1px solid #fff;
	border-collapse: collapse;
}

th,
td {
	padding: 5px;
}

th {
	text-align: left;
}

.form-inline {
	margin-top: 20px;
	margin-bottom: 20px;
}

.btn-pink {
	background-color: #e4467b;
	color: #fff;
	height: 50px;
	line-height: 2;
	margin: 10px 15px;
	cursor: pointer;
}

.custom-select {
	width: auto;
}

.btn-pink:hover {
	background-color: #e85183;
}

.btn-success {
	height: 50px;
	margin: 10px 15px;
}

.main-container {
	background: #453454;
	box-shadow: 0px 2.7795px 27.795px rgba(27, 14, 66, 0.3);
	border-radius: 5.559px;

	max-width: 910px;

	width: max-content;

	padding: 30px 20px;

	margin-right: auto;
	margin-left: auto;

	@media (max-width: 767px) {
		width: 100%;
	}
}

.main-container.white {
	background: #f2f2f2;
	box-shadow: 0px 4px 40px rgba(27, 14, 66, 0.3);
	border-radius: 8px;

	color: #150722;

	& table,
	& th,
	& td {
		border: 1px solid #150722;
		border-radius: 4px;
	}
}
</style>
